import Vue from 'vue'

export default {
  getStripeAccount (stripeAccountId) {
    return Vue.prototype.$http.get(`/stripe_accounts/${stripeAccountId}`)
  }
}
